import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store'
import ParameterButton from './ParameterButton'

interface TutorialButtonProps {
  handleBack?: () => void
}

const TutorialButton = ({ handleBack }: TutorialButtonProps): JSX.Element => {
  const translation = useSelector((state: RootState) => state.localeReducer.currentTranslations)

  const handleClick = (): void => {
    handleBack?.()
  }

  return <ParameterButton title={translation.tutorial.shorttitle} icon='tutorial' onClick={handleClick} />
}

export default TutorialButton
